var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DA322A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.122 59.372l-8.27-7.904c-.653-.624-1.71-.624-2.363 0-.652.623-.652 1.634 0 2.257l7.088 6.775-7.088 6.775c-.652.623-.652 1.634 0 2.257.652.624 1.71.624 2.363 0l8.27-7.904c.652-.622.652-1.633 0-2.256z",
    transform: "translate(-20 -51) rotate(-180 25.806 60.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3179015b.svg";
export { ForwardRef as ReactComponent };